<script lang="ts" setup>
import { readonly, toRef } from 'vue';

import { provideRowContext } from './model';

const props = defineProps<{
  index: number;
  rowKey: string;
  measureElement: (node: Element | null) => void;
}>();
provideRowContext({
  index: readonly(toRef(props, 'index')),
  key: readonly(toRef(props, 'rowKey')),
  measureElement: props.measureElement,
});
</script>
<template>
  <slot />
</template>
